import React from 'react'

type Props = {
  fieldProps: any
  touched: any
  errors: any
  displayText: string
  verticalLabel?: boolean
  rows: number
}

export const AncientInputTextArea: React.FC<Props> = ({
  displayText,
  fieldProps,
  touched,
  errors,
  verticalLabel,
  rows,
}) => {
  return (
    <>
      {verticalLabel ? (
        <div className='mb-5'>
          <label className='form-label'>{displayText}</label>
          <textarea
            className={
              'border form-control form-control-flush mb-3 rounded' +
              (errors !== undefined ? ' is-invalid border-danger' : '')
            }
            rows={rows}
            data-kt-element='input'
            placeholder={displayText}
            {...fieldProps}
          />
          {touched && errors && (
            <div className='fv-plugins-message-container mb-2 text-danger'>
              <p className='fv-help-block fs-6 mb-0'>{errors}</p>
            </div>
          )}
        </div>
      ) : (
        <div className='row mb-6'>
          <label className='col-lg-4 col-form-label required fw-bold fs-6'>{displayText}</label>

          <div className='col-lg-8'>
            <div className='row'>
              <div className='col-lg-12 fv-row'>
                <textarea
                  className='border form-control form-control-flush mb-3'
                  rows={rows}
                  data-kt-element='input'
                  placeholder={displayText}
                  {...fieldProps}
                />
                {touched && errors && (
                  <div className='fv-plugins-message-container mb-2 text-danger'>
                    <p className='fv-help-block fs-6 mb-0'>{errors}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
